/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseClasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Drawer {
    import DataMaintenanceSection = Meevo.Components.BaseClasses.IDataMaintenanceSection;
    "use strict";

    const TIPPY_SECTION_ID: number = 3;

    export class DrawerContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        protected timeout: ng.ITimeoutService;
        protected posCriteria: any;
        protected hardwareCriteria: any;
        public isEmailEnabled: boolean;
        public isTipEnabledForDrawer: boolean = true;
        public hasTerminalSignatureCaptureSupport: boolean = false;
        protected nullValue: any = null;
        protected isHostedPageAllowed: boolean = true;
        private merchantProviders: Meevo.Model.MerchantProvider[] = [];

        public SignatureEntryMethodEnum = Meevo.Model.SignatureEntryMethodEnum;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityService: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected printService: Meevo.Components.Common.IPrintService,
            $timeout: ng.ITimeoutService,
            protected $q: angular.IQService,
            protected $translate: angular.translate.ITranslateService,
            protected tippyDataService: Meevo.Components.Common.TippyDataService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityService, trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.drawer;
            this.sectionTemplatePath = "app/plugins/drawer/sectionViews/";
            this.entityType = "Drawer";
            this.buildCrudSecurityKeys(this.securityKeys.REGISTER_DRAWER_TAB_MAIN);
            this.timeout = $timeout;
            this.setPosCriteria();

            this.hardwareCriteria = {
                "ObjectStates": [2026]
            };

            securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_HOSTEDPAGE).then(result => {
                this.isHostedPageAllowed = result !== Model.SecurityAccessEnum.Hide;
            });

            this.getMerchantProviders();
            this.addTippySection();
        }

        private getMerchantProviders() {
            this.dataService.customMethodData("/api/location/merchantProviders", "GET", null).then((response) => {
                this.merchantProviders = response.data;
            });
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_DRAWER_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_DRAWER_MAIN",
                    "main.html",
                    true,
                    false,
                    this.appSettings.API_ENDPOINTS.drawer,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.Drawer,
                    null,
                    this.securityKeys.REGISTER_DRAWER_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_DRAWER_TAB_RECEIPT + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(1,
                    "SECTION_DRAWER_RECEIPT",
                    "receipt.html",
                    true,
                    false,
                    this.appSettings.API_ENDPOINTS.drawer,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.Drawer,
                    null,
                    this.securityKeys.REGISTER_DRAWER_TAB_RECEIPT + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_DRAWER_TAB_POSSTATION + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(2,
                    "SECTION_DRAWER_POS_STATIONS",
                    "posStations.html",
                    true,
                    false,
                    this.appSettings.API_ENDPOINTS.drawer,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.Drawer,
                    null,
                    this.securityKeys.REGISTER_DRAWER_TAB_POSSTATION + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }

            this.loadNotificationSettings();
        }

        addTippySection() {
            if (!this.identityService.inSandboxMode() &&
                this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_TIPPY + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.tippyDataService.getSection("", "config").then(config => {
                    if (config.accountToken && config.accountToken !== "") {
                        this.sections.push(new TippySection(TIPPY_SECTION_ID,
                            "SECTION_DRAWER_TIPPY",
                            "tippy.html",
                            true,
                            false,
                            this.appSettings.API_ENDPOINTS.drawer,
                            "",
                            this.loggingService,
                            null,
                            this.identityService,
                            Meevo.Model.NounEnum.Drawer,
                            null,
                            this.securityKeys.INTEGRATION_TIPPY + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
                    }
                })
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.REGISTER_DRAWER_TAB_RECEIPT, false, true);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.REGISTER_DRAWER_TAB_POSSTATION, false, true);
                    break;
                default: // Commom security strategy
                    this.buildCrudSecurityKeys(this.securityKeys.REGISTER_DRAWER_TAB_MAIN);
                    if (this.mode === Meevo.Model.MaintenanceFormState.Adding && !!this.itemId) {
                        this.itemId = undefined;
                    }
                    break;
            }
            if (this.selectedSection && this.selectedSection != item && this.navigationBlocked) {
                this.modalService.alert("MESSAGE_PENDING_CHANGES");
            } else {
                var prevSection = this.selectedSection;
                if (Model.Guard.isSomething(prevSection))
                    prevSection.prevUnselected(); // implement prevUnselected action

                this.selectedSection = item;

                if (!this.selectedSection.handlesOwnCrud && this.itemId) {
                    this.loadingInProgress = true;
                    var newSectionEndPoint = this.selectedSection.sectionEndpoint;

                    let baseEndpoint = Model.Guard.isSomething(this.selectedSection.baseEndpoint) ? this.selectedSection.baseEndpoint : this.baseEndpoint;
                    this.getSectionById(item.sectionId, baseEndpoint, newSectionEndPoint).then((data: any) => {
                        this.selectedSection.model = data;

                        if (this.selectedSection.model["creditCard"] != null)
                            this.selectedSection.model["creditCardId"] = this.selectedSection.model["creditCard"]["terminalId"];

                        if (this.selectedSection.model["merchantAccount"] != null && this.selectedSection.model["merchantAccount"]["id"] != null) {
                            this.merchantAccountChanged();
                        }

                        this.selectedSection.sectionModelRetrieved();
                        this.selectedSection.activate();

                        if (this.selectedSection.isPrimarySection) {
                            this.updateCoBarData(data);
                            this.initializeHeader(data);
                        }
                        this.setPosCriteria();

                    }).finally(() => {
                        this.loadingInProgress = false;
                    });
                }
                this.selectedSection.selected(); // implement selected action

                this.usageTrackingLog(Meevo.Model.VerbEnum.Viewed, null);
            }
        }

        getSectionById(sectionId: number, baseEndpoint: string, newSectionEndPoint: string,) {
            if (sectionId === TIPPY_SECTION_ID) {
                return this.loadTippyKiosk();
            }
            else {
                return this.dataService.getSectionById(baseEndpoint, this.itemId, newSectionEndPoint, this.asLocationId)
            }
        }

        loadTippyKiosk() {
            return this.tippyDataService.getKioskByDrawerId(this.itemId.toString()).then((kiosk:Model.TippyKiosk) => {

                if (kiosk && kiosk.lockedByUserId) {
                    return this.dataService.getItem('Employee', new Guid(kiosk.lockedByUserId)).then((emp: Model.Employee) => {
                        (kiosk as any).lockedByEmployeeDisplayName = emp.displayName || emp.userName;
                        return kiosk || { drawerId: this.itemId };
                    });
                }

                return kiosk || { drawerId: this.itemId };
            });
        }

        loadNotificationSettings() {
            this.dataService.customMethodData("api/notificationSetting", "GET", {}).then(result =>
                this.isEmailEnabled = result.data.isEmailEnabled
            );
        }

        get SelectedDevice(): Model.Drawer {
            return this.castModel<Model.Drawer>();
        }

        addPosStation(): void {
            var drawer = this.SelectedDevice;
            if (drawer === undefined || drawer.posStation === undefined)
                return;

            if (_.find(drawer.posStation !== undefined
                && drawer.posStations, (ec) =>
                { return ec.displayName === drawer.posStation.displayName }) === undefined) {
                {
                    drawer.posStations.push(drawer.posStation);
                    drawer.posStation = undefined;
                }
            }
        }

        removePosStation(index: number): void {
            var drawer = this.SelectedDevice;
            if (drawer === undefined) {
                return;
            }
            drawer.posStations.splice(index, 1);
        }

        communicateWithPrinter(device: any): void {
            switch (device.brandId) {
                case 1:
                case 2:
                    const printerDetail: Meevo.Components.Common.IPrintServicePrinter = {
                        brandId: device.brandId,
                        displayName: device.deviceName,
                        deviceName: device.deviceName,
                        ribbonSize: +device.ribbonSize,
                        id: device.id,
                        ipAddress: device.ipAddress,
                        port: Number(device.port),
                        isTrustEnabled: device.isTrustEnabled,
                    };

                    this.printService.printToDevice(printerDetail, "/api/receipt/testtemplate/").catch(() => {
                        //this.modalService.alert("MESSAGE_UNABLE_TO_CONNECT_TO_PRINTER");
                    });
                    break;
            }
        }

        postCopy(): void {
            super.postCopy();
            const model = this.castModel<Model.Drawer>();
            model.displayName = undefined;
        }

        isReceiptMessageEnabledForEdit(): boolean {
            const key = this.securityKeys.REGISTER_DRAWER_FIELD_RECEIPTMESSAGE + this.securityParts.KEY_PART_WRITE;
            return (this.securityChecker.hasSecurity(key));
        }

        isPhysicalTerminalAvailable(merchantAccount): boolean {
            if (!merchantAccount) {
                return false;
            }

            return true;
        }

        merchantAccountChanged(): void {
            if (this.selectedSection.model["merchantAccount"] != null && this.selectedSection.model["merchantAccount"]["id"] != null) {
                const merchantAccountId = this.selectedSection.model["merchantAccountId"] = this.selectedSection.model["merchantAccount"]["id"]; // make sure ID is assigned so that the value pushed to DB will save
                this.getMerchantAccountTerminals(merchantAccountId).then(() => {
                    const merchantAccount = _.findWhere(this.selectedSection["merchantAccounts"], { "merchantAccountId": this.selectedSection.model["merchantAccount"]["id"] });
                    const drawer = (<Model.Drawer>this.selectedSection.model);

                    this.isTipEnabledForDrawer = merchantAccount ? merchantAccount["isTipEnable"] : false;
                    if (!this.isTipEnabledForDrawer) {
                        drawer.tipEntryMethodEnum = Meevo.Model.TipEntryMethodEnum.OnScreen;
                    }

                    this.hasTerminalSignatureCaptureSupport = merchantAccount ? merchantAccount["hasTerminalSignatureCaptureSupport"] : false;
                    if (!this.hasTerminalSignatureCaptureSupport && drawer.signatureEntryMethodEnum === Meevo.Model.SignatureEntryMethodEnum.OnTerminal) {
                        drawer.signatureEntryMethodEnum = Meevo.Model.SignatureEntryMethodEnum.OnReceipt;
                    }

                    this.timeout(() => {
                        $("body").click();
                    }, 400);
                });
            } else { // user just cleared the value for merchant account
                this.selectedSection.model["merchantAccountId"] = null;
                this.selectedSection.model["creditCardId"] = null;
                this.isTipEnabledForDrawer = false;
                this.hasTerminalSignatureCaptureSupport = false;
            }
        }

        getDefaultMerchantAccount(): ng.IPromise<Meevo.Model.MerchantAccount> {
            const request = {
                criteria: {
                    getDefaultAccountOnly: true,
                }
            };

            return this.dataService.customMethodData(`api/merchantAccount/list`, "POST", request).then((response) => {
                if (response.data && response.data.length > 0) {
                    return response.data[0];
                }
                return null;
            });
        }

        merchantAccountPreProcess(response, request) {
            for (let index = response.length - 1; index >= 0; index--) {
                const merchantAccount = response[index];
                const merchantProvider = _(this.merchantProviders).find(provider => provider.id === merchantAccount.merchantProviderId);
                if (!merchantProvider ||
                    !merchantProvider.hasRegisterSupport ||
                    merchantProvider.id === Meevo.Model.MerchantAccountProviderEnum.CareCredit ||
                    merchantProvider.id === Meevo.Model.MerchantAccountProviderEnum.WorldpayGC) {
                    response.splice(index, 1);
                }
            }
        }

        getMerchantAccountTerminals(merchantAccountId: string) {
            const request = {
                criteria: {
                    isHostedMode: this.isHostedPageAllowed,
                }
            };

            return this.dataService.customMethodData(`api/merchantAccount/${merchantAccountId}/devices/list`, "POST", request).then((response) => {

                this.selectedSection["merchantAccounts"] = response.data;
                this.selectedSection["merchantAccountTerminals"] = [];

                if (this.selectedSection["merchantAccounts"] != null) {
                    // loop through merchant accounts & concatenate the display names from Accounts & Terminals
                    for (let index = 0; index < this.selectedSection["merchantAccounts"].length; index++) {
                        let merchantTerminal = this.selectedSection["merchantAccounts"][index];

                        switch (merchantTerminal.merchantTerminalType) {
                            case Meevo.Model.MerchantTerminalTypeEnum.Physical:
                                merchantTerminal.displayName = this.selectedSection.model["merchantAccount"].displayName + ":" + this.selectedSection["merchantAccounts"][index].displayName;
                                break;

                            case Meevo.Model.MerchantTerminalTypeEnum.Hosted:
                                merchantTerminal.displayName = this.selectedSection.model["merchantAccount"].displayName + ":" + this.$translate.instant('LABEL_HOSTED_PAGE');
                                break;
                        }

                        this.selectedSection["merchantAccountTerminals"].push(merchantTerminal);

                        if (this.selectedSection.model["creditCard"].terminalId == this.selectedSection["merchantAccounts"][index]["id"]) {
                            this.selectedSection.model["creditCardId"] = this.selectedSection["merchantAccounts"][index]["id"];
                        }
                    }
                }
            });
        }

        update(entity: any): angular.IPromise<any> {
            if (this.selectedSection.sectionId === TIPPY_SECTION_ID) {
                entity = <Model.TippyKiosk>entity;
                if (angular.isDefined(entity.deviceId) && entity.deviceId !== "") {
                    return this.tippyDataService.addKiosk(this.itemId.toString(), entity.deviceId).catch((error) => {
                        return this.$q.reject(error.data.message);
                    });
                }
                else if (angular.isDefined(entity.originalDeviceId) && entity.originalDeviceId !== "") {
                    return this.tippyDataService.deleteKiosk(entity.originalDeviceId, this.itemId.toString()).then(() => {
                        return { drawerId: this.itemId };
                    }).catch(error => {
                        return this.$q.reject(error.data.message);
                    });
                }
                else {
                    return this.$q.resolve({ drawerId: this.itemId });
                }
            }
            else {
                return this.dataService.update(this.baseEndpoint, entity, this.itemId, this.selectedSection.sectionEndpoint, this.asLocationId)
            }
        }

        save(): angular.IPromise<any> {
            let addingMode = this.mode === Meevo.Model.MaintenanceFormState.Adding;

            if (this.canSave) {

                this.selectedSection.preSave();
                this.loadingInProgress = true;

                //don't use finally on the promises below. this should be skipped if there is a warning
                //postAdd dismisses the data maint form.
                let finallyFcn = () => {
                    this.loadingInProgress = false;
                    this.updateCoBarData(this.selectedSection.model);

                    if (this.customDataContextConfig && this.customDataContextConfig.use) {
                        if (addingMode) {
                            // if entity didn't have id (wasn't created or copied yet)

                            this.selectedSection.customControlsModel.answers.map(answer => {
                                answer.entity_Id = this.selectedSection.model.id;

                                return answer;
                            });
                        }

                        this.selectedSection.saveCustomControls();
                    }
                };

                if (this.mode === Meevo.Model.MaintenanceFormState.Adding || this.mode === Meevo.Model.MaintenanceFormState.Copying) {
                    return this.dataService.add(this.baseEndpoint, this.selectedSection.model, this.itemId, this.selectedSection.sectionEndpoint)
                        .then((data: any) => {
                            if (data.isWarning) {
                                super.handleWarnings(data.responseStatus.errors);
                            } else {
                                this.itemId = data.id;
                                for (let i = 0; i < this.sections.length; i++) {
                                    this.sections[i].setParentItemId(this.itemId);
                                }
                                this.selectedSection.model = data;
                                this.selectedSection.sectionModelRetrieved();
                                this.setMode(Model.MaintenanceFormState.Readonly);
                                this.loggingService.trace(`New item saved.`);
                                this.postAdd(this.selectedSection.model);
                                finallyFcn();
                                this.merchantAccountChanged();
                            }
                        })
                        .catch((reason: any) => {
                            this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                            //finallyFcn();
                            this.loadingInProgress = false;
                        });
                    // Handling location override
                } else {
                    // For overrides pass as location override contract
                    if (super.getTakeOwnershipValue()) {
                        this.selectedSection.model.locationId = this.identityService.current().centralOfficeId;
                        this.selectedSection.model.homeLocationId = this.identityService.current().centralOfficeId;
                        this.selectedSection.model.availableToLocations = true;
                    }
                    var updateModel = this.isApplicationModeCO() ? <Model.IHasLocationOverride>this.selectedSection.model : this.selectedSection.model;
                    if (this.allowsCentralOfficeOptions)
                        this.buildOverrideFieldList();
                    return this.update(updateModel)
                        .then((data: any) => {
                            if (data.isWarning) {
                                super.handleWarnings(data.responseStatus.errors);
                            } else {
                                this.selectedSection.model = data;
                                this.selectedSection.sectionModelRetrieved();
                                this.setMode(Model.MaintenanceFormState.Readonly);
                                this.loggingService.trace(`Updates saved.`);
                                this.postUpdate(this.selectedSection.model);
                                finallyFcn();
                                this.merchantAccountChanged();
                            }
                        })
                        .catch((reason: any) => {
                            this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                            //finallyFcn();
                            this.loadingInProgress = false;
                        });
                }
            }
        }

        setPosCriteria(): any {
            if (this.selectedSection != null &&
                this.selectedSection.model != null &&
                this.selectedSection.model["merchantAccount"] != null &&
                this.selectedSection.model["merchantAccount"]["id"] != null) {
                this.posCriteria = {
                    merchantAccountId: this.selectedSection.model["merchantAccount"]["id"]
                };
            } else {
                this.posCriteria = {
                };
            }
        }

        manualUnlockTippyKiosk() {
            var tippySection = this.selectedSection as TippySection;

            if (!tippySection)
            {
                return;
            }

            this.modalService.yellowConfirm('MESSAGE_TIPPY_KIOSK_UNLOCK', Components.Modal.ModalTranslationModes.Translate, false)
                .then(response => {
                    if (response) {
                        this.tippyDataService.unlockKiosk(tippySection.model.deviceId).then(() => this.loadTippyKiosk()
                            .then((kiosk: Model.TippyKiosk) => tippySection.model = kiosk));
                    }
                });
        }
    }
}